import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 0C8.53125 0 9 0.46875 9 1V1.625C11.2812 2.0625 13 4.09375 13 6.5V7.3125C13 8.71875 13.4688 10.0938 14.3438 11.2188L14.8125 11.7812C15 12.0312 15.0312 12.3438 14.9062 12.5938C14.7812 12.8438 14.5312 13 14.25 13H1.75C1.4375 13 1.1875 12.8438 1.0625 12.5938C0.9375 12.3438 0.96875 12.0312 1.15625 11.7812L1.625 11.2188C2.5 10.0938 3 8.71875 3 7.3125V6.5C3 4.09375 4.71875 2.0625 7 1.625V1C7 0.46875 7.4375 0 8 0ZM8 3C6.0625 3 4.5 4.59375 4.5 6.5V7.3125C4.5 8.8125 4.0625 10.25 3.25 11.5H12.7188C11.9062 10.25 11.5 8.8125 11.5 7.3125V6.5C11.5 4.59375 9.90625 3 8 3ZM10 14C10 14.5312 9.78125 15.0625 9.40625 15.4375C9.03125 15.8125 8.53125 16 8 16C7.46875 16 6.9375 15.8125 6.5625 15.4375C6.1875 15.0625 6 14.5312 6 14H8H10Z",
		fill: "white",
		fillOpacity: .5
	})
});
export { SvgBell as ReactComponent };
